import { Trans, useTranslation } from 'react-i18next';

import { useAnyOrganizationUsersFiltersActive } from '../../../../../../features/organization';
import { EmptyState } from '../../../../empty-state';
import { INoUsersProps } from './types';

export const NoUsers = ({ expanded }: INoUsersProps) => {
  const { t } = useTranslation();
  const anyFiltersActive = useAnyOrganizationUsersFiltersActive();

  return (
    <EmptyState
      title={t(`organization.users.empty.title.${expanded || !anyFiltersActive ? 'noUsers' : 'noResult'}`)}
      subtitle={
        <Trans
          i18nKey={`organization.users.empty.subtitle.${
            !expanded ? 'noUsers' : anyFiltersActive ? 'noResult' : 'noUsersExtended'
          }`}
          components={[<span key="span" className="typography-inline-highlight-3" />]}
        />
      }
    />
  );
};
